import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getUserOrganizations, getRoles } from "../../../modules/user.js";
import ManagePersonnel from "./manage-personnel/manage-personnel.js";

import "./regional-manager-dashboard.css";

class RegionalManagerDashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            organizations: [],
            roles: []
        };
    }

    addNewlyAddedOrganizationToList(newOrganization) {
        let { organizations } = this.state;
        let newOrganizationList = [...organizations, newOrganization]
        this.setState({ organizations: newOrganizationList });
    }

    async componentDidMount() {
        let { token } = this.props;
        let organizationsResponse = await getUserOrganizations(token);

        if (organizationsResponse.data.success) {
            let organizations = organizationsResponse.data.organizations;
            this.setState({ organizations: organizations });
        }

        let rolesResponse = await getRoles(token);

        if (rolesResponse.data.success) {
            let roles = rolesResponse.data.roles;
            this.setState({ roles: roles });
        }
    }

    render() {
        let { token, currentUser } = this.props;
        let { organizations, roles } = this.state;

        return (
            <div className='regional_manager_dashboard'>
                <div className='regional_manager_dashboard_title'>Welcome to your dashboard</div>
                <ManagePersonnel organizations={organizations} token={token} roles={roles} user={currentUser} add_new_organization_func={this.addNewlyAddedOrganizationToList.bind(this)} />
            </div>
        )
    }
}

const withState = connect(state => {
    const { user } = state;
    return {
        token: user.token,
        currentUser: user,
        currentUserId: user.currentUserId,
        currentUserFirstName: user.currentUserFirstName,
    };
});

export default withRouter(withState(RegionalManagerDashboard));


// WEBPACK FOOTER //
// ./src/components/containers/manager-dashboard/regional-manager-dashboard.js